module.exports = {
  goodsThreePoint:
    'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/common/goods/three_point.png',
}
